// extracted by mini-css-extract-plugin
module.exports = {"projects":"Portfolio_projects__3RLnr","searchButtons":"Portfolio_searchButtons__1H57c","searchParametersTitle":"Portfolio_searchParametersTitle__1sKux"};